import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { useRoutePlanEdit } from './apiHooks';
import Helmet from 'react-helmet';

const AdminRoutePlanRefresh = ({ routePlan }) => {
  const { editRoutePlan } = useRoutePlanEdit();
  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.route.planning.refresh.header' }, { routePlanId: routePlan.id })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={'admin.route.planning.refresh.header'} values={{ routePlanId: routePlan.id }} />
      </h3>

      <p>
        <FormattedMessage
          id={'admin.route.planning.refresh.current.status'}
          values={{ status: routePlan.routeOptimisationResult ? routePlan.routeOptimisationResult.status : '-' }}
        />
      </p>

      <div>
        <button
          className="btn btn-primary"
          onClick={() => editRoutePlan({ routePlan, params: { refreshRouteOptimisationStatus: true } })}
        >
          <FormattedMessage id={'admin.route.planning.refresh.cta'} />
        </button>
      </div>
    </div>
  );
};

export default AdminRoutePlanRefresh;
